module.exports = __webpack_public_path__ + "assets/images/google-slides-icon.ceb47cabb4e4a0d36053696140c3d005.svg";